import * as DropdownMenu from '@radix-ui/react-dropdown-menu'

function initials(name) {
  return String(name || 'U')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
}

export default function TopbarAvatarMenu({
  userIdentity,
  avatarLoadError,
  onAvatarError,
  isProctoringActive,
  onAccount,
  accountDisabled = false,
  onSubscriptions,
  onSettings,
  onLogout,
  isEmployee = false,
}) {
  return (
    <DropdownMenu.Root modal={false}>
      <div className="topbar-avatar-menu">
        <DropdownMenu.Trigger asChild>
          <button type="button" className="topbar-avatar-trigger" aria-label="Open profile menu">
            {userIdentity.avatarUrl && !avatarLoadError ? (
              <img
                src={userIdentity.avatarUrl}
                alt={userIdentity.name}
                className="profile-avatar-img"
                onError={onAvatarError}
              />
            ) : (
              <div className="profile-avatar">{initials(userIdentity.name)}</div>
            )}
            <span
              className={`proctoring-dot ${isProctoringActive ? 'active' : 'inactive'}`}
              title={isProctoringActive ? 'Proctoring active' : 'Proctoring inactive'}
              aria-label={isProctoringActive ? 'Proctoring active' : 'Proctoring inactive'}
            />
          </button>
        </DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <DropdownMenu.Content
            align="end"
            sideOffset={10}
            className="topbar-avatar-dropdown"
          >
            <DropdownMenu.Item
              disabled={accountDisabled}
              className={`topbar-avatar-item ${accountDisabled ? 'topbar-avatar-item-disabled' : ''}`}
              onSelect={(event) => {
                if (accountDisabled) {
                  event.preventDefault()
                  return
                }
                onAccount?.(event)
              }}
            >
              <span className="material-symbols-outlined">{isEmployee ? 'person' : 'badge'}</span>
              <span>{isEmployee ? 'My Profile' : 'Account'}</span>
            </DropdownMenu.Item>
            {!isEmployee && (
              <>
                <DropdownMenu.Item
                  className="topbar-avatar-item"
                  onSelect={() => onSubscriptions?.()}
                >
                  <span className="material-symbols-outlined">card_membership</span>
                  <span>Subscriptions &amp; Marketplace</span>
                </DropdownMenu.Item>
                <DropdownMenu.Item
                  className="topbar-avatar-item"
                  onSelect={() => onSettings?.()}
                >
                  <span className="material-symbols-outlined">mark_email_read</span>
                  <span>Email &amp; Notification Settings</span>
                </DropdownMenu.Item>
              </>
            )}
            <DropdownMenu.Separator className="topbar-avatar-divider" />
            <DropdownMenu.Item className="topbar-avatar-item topbar-avatar-item-danger" onSelect={onLogout}>
              <span className="material-symbols-outlined">logout</span>
              <span>Logout</span>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </div>
    </DropdownMenu.Root>
  )
}
